module.exports = __webpack_public_path__ + "static/media/instagram-white.f56f9fa3.svg";